import { useTranslation } from "react-i18next";

export function BillingToggle({ isYearly, onChange }) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center gap-4 mb-8">
            <span className={`text-sm font-medium ${!isYearly ? "text-foreground" : "text-muted-foreground"}`}>
                {t("billing.supportPlans.monthly")}
            </span>
            <button
                type="button"
                role="switch"
                aria-checked={isYearly}
                onClick={() => onChange(!isYearly)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isYearly ? "bg-blue-600" : "bg-gray-200"}`}
            >
                <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${isYearly ? "translate-x-6" : "translate-x-1"}`} />
            </button>
            <span className={`text-sm font-medium ${isYearly ? "text-foreground" : "text-muted-foreground"}`}>
                {t("billing.supportPlans.yearly")} <span className="text-green-600">{t("billing.supportPlans.save20")}</span>
            </span>
        </div>
    );
}
